/* =====================================================================
   PENDELLE — comportements communs du thème (sans dépendance)
   Repris de la maquette validée + logique Ajax du panier (API Shopify).
   Tout est exposé dans window.PD (voir ~/pendelle/BASE_NOTES.md) :
     PD.money(cents)            « 291,90 € » (format de la maquette)
     PD.nb(racine)              espaces insécables de la typographie française
     PD.observe(racine)         apparitions au défilement ([data-rv] → .in)
     PD.openLayer(id) / PD.closeLayer()   calques : 'ovCart', 'ovMenu', 'ovSearch', ou tout .ov#id
     PD.openMega(id) / PD.closeMega()
     PD.refreshCart(ouvrir)     recharge le panier latéral (section pd-cart-drawer) → Promise(cart)
     PD.addItems([{id, quantity, properties}])  ajoute puis ouvre « Votre sélection » → Promise(cart)
     PD.addForm(form)           ajoute le contenu d'un formulaire produit (FormData) → Promise(cart)
     PD.changeLine(ligne, qté)  → Promise(cart)
     PD.applyDiscount(code)     → Promise(cart)
     PD.etaDate(jours)          « mardi 28 octobre » (jours ouvrés)
     PD.instText(cents)         « ou 3 × 97,30 € sans frais » (ou '' si désactivé)
     PD.updatePrices(racine, variante)   met à jour [data-price] [data-compare] [data-inst] d'une zone
     PD.init(racine)            relance tout sur un fragment (éditeur de thème, contenu chargé en Ajax)
   Événements émis sur document : 'pd:cart' (detail = panier JSON), 'pd:layer' (detail = {id, open}).
   ===================================================================== */
(function () {
  'use strict';
  var PD = window.PD = window.PD || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var S = PD.settings || {};
  PD.routes = PD.routes || {};
  var R = {
    cartAdd: PD.routes.cartAdd || ROOT + 'cart/add.js',
    cartChange: PD.routes.cartChange || ROOT + 'cart/change.js',
    cartUpdate: PD.routes.cartUpdate || ROOT + 'cart/update.js',
    cartJson: PD.routes.cartJson || ROOT + 'cart.js',
    suggest: PD.routes.suggest || ROOT + 'search/suggest.json'
  };
  PD.$ = $; PD.$$ = $$; PD.RM = RM;

  /* ------------------------------------------------------------ argent */
  function money(c) {
    c = Math.round(+c || 0);
    var neg = c < 0; c = Math.abs(c);
    var e = Math.floor(c / 100), d = c % 100;
    var es = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (neg ? '−' : '') + es + ',' + (d < 10 ? '0' : '') + d + ' €';
  }
  PD.money = money;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  PD.esc = esc;

  /* ------------------------------------------------------------ paiement en plusieurs fois */
  function instText(cents) {
    var I = S.installments || {};
    if (!I.on || !(cents > 0) || cents < (I.min || 0)) return '';
    var n = I.count || 3;
    return 'ou ' + n + ' × ' + money(Math.round(cents / n)) + ' sans frais';
  }
  PD.instText = instText;
  function updatePrices(scope, v) {
    if (!scope || !v) return;
    $$('[data-price]', scope).forEach(function (el) { el.textContent = money(v.price); });
    $$('[data-compare]', scope).forEach(function (el) {
      var on = v.compare_at_price && v.compare_at_price > v.price;
      el.hidden = !on; el.textContent = on ? money(v.compare_at_price) : '';
    });
    $$('[data-inst]', scope).forEach(function (el) {
      var t = instText(v.price), I = S.installments || {}, n = I.count || 3;
      el.hidden = !t;
      if (t) el.innerHTML = 'ou <b data-x3>' + n + ' × ' + money(Math.round(v.price / n)) + '</b> sans frais' + esc(el.getAttribute('data-suffix') || '');
    });
  }
  PD.updatePrices = updatePrices;

  /* ------------------------------------------------------------ typographie française (maquette : nb) */
  function nb(root) {
    if (DESIGN || !document.createTreeWalker) return;
    root = root || document.body;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, t;
    while ((n = w.nextNode())) {
      var pn = n.parentNode && n.parentNode.nodeName;
      if (pn === 'SCRIPT' || pn === 'STYLE' || pn === 'text' || pn === 'tspan' || pn === 'TEXTAREA' || pn === 'OPTION' || pn === 'title') continue;
      t = n.nodeValue;
      var u = t.replace(/ ([?!:;»])/g, ' $1').replace(/« /g, '« ')
        .replace(/(\d) (€|cm|m²|m\b|%|W\b|h\b|jours|ans|globes|couverts)/g, '$1 $2')
        .replace(/(\d) (\d{3})/g, '$1 $2');
      if (u !== t) n.nodeValue = u;
    }
  }
  PD.nb = nb;

  /* ------------------------------------------------------------ apparitions au défilement */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px 6% 0px', threshold: .01 }) : null;
  function revealNow(root) {
    var h = window.innerHeight || 800;
    $$('[data-rv]:not(.in)', root || document).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width && r.top < h * 1.04 && r.bottom > -20) el.classList.add('in');
    });
  }
  function observe(root) {
    root = root || document;
    $$('[data-rv]:not(.in)', root).forEach(function (el) { if (io && !RM && !DESIGN) io.observe(el); else el.classList.add('in'); });
    revealNow(root);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { revealNow(root); });
  }
  PD.observe = observe; PD.revealNow = revealNow;

  /* ------------------------------------------------------------ dates de livraison (jours ouvrés) */
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function dfr(d) { return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }); }
  function etaDate(n) { return dfr(addBiz(new Date(), +n || 0)); }
  PD.etaDate = etaDate;
  function fillEta(root) {
    $$('[data-eta-days]', root || document).forEach(function (s) { s.textContent = etaDate(s.getAttribute('data-eta-days')); });
    $$('[data-eta1]', root || document).forEach(function (s) { s.textContent = etaDate(S.shipMin || 7); });
    $$('[data-eta2]', root || document).forEach(function (s) { s.textContent = etaDate(S.shipMax || 12); });
  }
  PD.fillEta = fillEta;

  /* ------------------------------------------------------------ calques (panier, menu, recherche, filtres, zoom) */
  var openOv = null, lastFocus = null;
  function emit(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} }
  function openLayer(id) {
    var ov = document.getElementById(id); if (!ov) return;
    closeMega();
    if (openOv && openOv !== ov) closeLayer(openOv, true);
    lastFocus = document.activeElement;
    ov.classList.add('open'); ov.setAttribute('aria-hidden', 'false'); openOv = ov;
    document.documentElement.style.overflow = 'hidden';
    var inp = $('input[type=search]', ov);
    if (inp) setTimeout(function () { inp.focus(); }, 80);
    else { var f = $('.x', ov); if (f) setTimeout(function () { f.focus(); }, 60); }
    emit('pd:layer', { id: id, open: true });
  }
  function closeLayer(ov, silent) {
    ov = ov || openOv; if (!ov) return;
    ov.classList.remove('open'); ov.setAttribute('aria-hidden', 'true');
    if (openOv === ov) openOv = null;
    document.documentElement.style.overflow = '';
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
    emit('pd:layer', { id: ov.id, open: false });
  }
  PD.openLayer = openLayer; PD.closeLayer = closeLayer;
  /* garde le focus clavier dans le calque ouvert */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !openOv) return;
    var f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', openOv)
      .filter(function (x) { return x.offsetWidth || x.offsetHeight || x.getClientRects().length; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* ------------------------------------------------------------ méga-menus */
  var megaT;
  function openMega(id) {
    $$('.mega').forEach(function (m) { m.classList.toggle('open', m.id === id); });
    $$('[data-mega]').forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-mega') === id)); });
  }
  function closeMega() {
    $$('.mega').forEach(function (m) { m.classList.remove('open'); });
    $$('[data-mega]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  PD.openMega = openMega; PD.closeMega = closeMega;
  function bindHeader(scope) {
    var hd = $('#hd', scope) || $('#hd'); if (!hd || hd.__pd) return; hd.__pd = 1;
    var hover = function () { return window.matchMedia && window.matchMedia('(hover:hover)').matches; };
    $$('[data-mega]', hd).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); var id = b.getAttribute('data-mega'); if (b.getAttribute('aria-expanded') === 'true') closeMega(); else openMega(id); });
      b.addEventListener('mouseenter', function () { if (hover()) { clearTimeout(megaT); megaT = setTimeout(function () { openMega(b.getAttribute('data-mega')); }, 120); } });
    });
    $$('.nav>a', hd).forEach(function (a) { a.addEventListener('mouseenter', function () { clearTimeout(megaT); megaT = setTimeout(closeMega, 150); }); });
    hd.addEventListener('mouseleave', function () { clearTimeout(megaT); megaT = setTimeout(closeMega, 220); });
    hd.addEventListener('mouseenter', function () { clearTimeout(megaT); });
    $$('.mega', hd).forEach(function (m) { m.addEventListener('mouseenter', function () { clearTimeout(megaT); }); });
  }

  /* ------------------------------------------------------------ défilement : en-tête pilule, barre d'achat collante */
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var hd = $('#hd'); if (hd) hd.classList.toggle('small', y > 60);
    revealNow();
    $$('.sticky-buy[data-target]').forEach(function (sb) {
      var btn = $(sb.getAttribute('data-target')); if (!btn) return;
      var r = btn.getBoundingClientRect(), mob = window.innerWidth < 760;
      var ft = $('.ft'), foot = ft ? ft.getBoundingClientRect().top < window.innerHeight - 40 : false;
      sb.classList.toggle('on', mob && r.bottom < 70 && !foot);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  PD.onScroll = onScroll;

  /* ------------------------------------------------------------ lueur du bandeau, panneaux de matières */
  function bindFx(scope) {
    $$('.hero', scope).forEach(function (hero) {
      if (hero.__pd || RM) return; hero.__pd = 1;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        hero.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
    $$('.mats', scope).forEach(function (box) {
      if (box.__pd) return; box.__pd = 1;
      $$('.mat', box).forEach(function (m) { m.addEventListener('mouseenter', function () { $$('.mat', box).forEach(function (x) { x.classList.toggle('on', x === m); }); }); });
    });
    $$('[data-tabs]', scope).forEach(function (group) {
      if (group.__pd) return; group.__pd = 1;
      var tabs = $$('[role=tab]', group);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab; t.setAttribute('aria-selected', String(on)); t.setAttribute('tabindex', on ? '0' : '-1');
            var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
          });
        });
        tab.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(tab), j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -9;
          if (j === -9) return; j = (j + tabs.length) % tabs.length; tabs[j].focus(); tabs[j].click();
        });
      });
    });
    /* bandeau d'annonce : plusieurs messages en fondu */
    $$('[data-ann-rotate]', scope).forEach(function (ann) {
      if (ann.__pd) return; ann.__pd = 1;
      var items = $$('.pd-ann-m', ann); if (items.length < 2 || RM) return;
      var i = 0;
      setInterval(function () { items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on'); }, 4000);
    });
  }

  /* ------------------------------------------------------------ clics globaux */
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-close]')) && el.closest('.ov')) { e.preventDefault(); closeLayer(el.closest('.ov')); return; }
    if ((el = t.closest('[data-open]'))) {
      e.preventDefault(); var id = el.getAttribute('data-open');
      if (id === 'ovCart') { refreshCart(true); } else openLayer(id);
      return;
    }
    if ((el = t.closest('.acc-b'))) {
      var ex = el.getAttribute('aria-expanded') === 'true'; el.setAttribute('aria-expanded', String(!ex));
      if (el.nextElementSibling) el.nextElementSibling.classList.toggle('open', !ex); return;
    }
    if ((el = t.closest('[data-sub]'))) {
      var ex2 = el.getAttribute('aria-expanded') === 'true'; el.setAttribute('aria-expanded', String(!ex2));
      var s = document.getElementById(el.getAttribute('data-sub')); if (s) s.classList.toggle('open', !ex2); return;
    }
    if ((el = t.closest('.fg>button'))) {
      var ex3 = el.getAttribute('aria-expanded') === 'true'; el.setAttribute('aria-expanded', String(!ex3));
      if (el.nextElementSibling) el.nextElementSibling.classList.toggle('open', !ex3); return;
    }
    if (!t.closest('.mega') && !t.closest('[data-mega]')) closeMega();
    /* carte produit : toute la carte est cliquable, comme dans la maquette */
    if ((el = t.closest('.card[data-href]')) && !t.closest('a,button,input,label,select')) { window.location.href = el.getAttribute('data-href'); return; }
    /* ancres du menu latéral (FAQ, guide) */
    if ((el = t.closest('.sidenav a[href^="#"], .toc a[href^="#"]'))) {
      var tg = document.querySelector(el.getAttribute('href'));
      if (tg) { e.preventDefault(); window.scrollTo({ top: tg.getBoundingClientRect().top + window.pageYOffset - 120, behavior: RM ? 'auto' : 'smooth' }); }
      $$('.sidenav a', el.parentNode).forEach(function (x) { x.classList.toggle('on', x === el); });
      return;
    }
    /* sélecteur de quantité générique : [data-qty] > bouton − , output|input, bouton + */
    if ((el = t.closest('[data-qty] button'))) {
      var box = el.parentNode, out = $('output,input', box); if (!out) return;
      var mx = +(box.getAttribute('data-max') || 99), cur = +(out.value || out.textContent) || 1;
      var n = Math.max(1, Math.min(mx, cur + (el === box.firstElementChild ? -1 : 1)));
      if ('value' in out && out.tagName === 'INPUT') { out.value = n; out.dispatchEvent(new Event('change', { bubbles: true })); } else out.textContent = n;
      return;
    }
    /* panier latéral */
    if ((el = t.closest('[data-cq]'))) { e.preventDefault(); busy(el); changeLine(+el.getAttribute('data-cq'), +el.getAttribute('data-q'), el.getAttribute('data-cq-group') || ''); return; }
    if ((el = t.closest('[data-add-variant]'))) { e.preventDefault(); busy(el); addItems([{ id: +el.getAttribute('data-add-variant'), quantity: 1 }]).catch(function (err) { unbusy(el); cartMsg(err.message); }); return; }
    if ((el = t.closest('[data-code-apply]'))) {
      e.preventDefault(); var inp = $('[data-code-input]', el.closest('.cart-code') || document);
      var code = inp && inp.value.trim(); if (code) { busy(el); applyDiscount(code); } return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (openOv) closeLayer(); closeMega(); }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-code-input]')) { e.preventDefault(); var b = $('[data-code-apply]', e.target.closest('.cart-code')); if (b) b.click(); }
  });
  function busy(el) { el.classList.add('is-loading'); el.setAttribute('aria-busy', 'true'); }
  function unbusy(el) { el.classList.remove('is-loading'); el.removeAttribute('aria-busy'); }

  /* ------------------------------------------------------------ panier (API Ajax Shopify) */
  function cartMsg(txt) { var m = $('#ovCart [data-code-msg]') || $('#ovCart [data-cart-msg]'); if (m) m.textContent = txt || ''; }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Une erreur est survenue, merci de réessayer.'); return j; }); });
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.setAttribute('data-n', n); });
    $$('[data-cart-label]').forEach(function (b) { b.setAttribute('aria-label', 'Ouvrir le panier, ' + n + ' article' + (n > 1 ? 's' : '')); });
  }
  PD.updateCount = updateCount;
  function refreshCart(open) {
    var drawer = document.getElementById('ovCart');
    var p1 = fetch(ROOT + '?sections=pd-cart-drawer', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return {}; });
    var p2 = fetch(R.cartJson, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    return Promise.all([p1, p2]).then(function (res) {
      var html = res[0] && res[0]['pd-cart-drawer'];
      if (html && drawer) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fs = $('.sheet', tmp), cs = $('.sheet', drawer);
        if (fs && cs) {
          cs.setAttribute('data-empty', fs.getAttribute('data-empty'));
          $$('[data-cart-part]', tmp).forEach(function (part) {
            var k = part.getAttribute('data-cart-part'), cur = $('[data-cart-part="' + k + '"]', drawer);
            if (cur && k !== 'express') cur.replaceWith(part);
          });
          nb(cs); fillEta(cs);
        }
      }
      updateCount((res[1].items || []).reduce(function (n, i) { return i.product_type === 'Ampoule' ? n : n + i.quantity; }, 0));
      if (open) openLayer('ovCart');
      emit('pd:cart', res[1]);
      return res[1];
    });
  }
  PD.refreshCart = refreshCart;
  function addItems(items) {
    return postJSON(R.cartAdd, { items: items }).then(function () { return refreshCart(true); });
  }
  PD.addItems = addItems;
  function addForm(form) {
    var fd = new FormData(form);
    return fetch(R.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Impossible d’ajouter ce luminaire.'); return j; }); })
      .then(function () { return refreshCart(true); });
  }
  PD.addForm = addForm;
  /* Article scindé en plusieurs lignes par Shopify (remise « Achetez X, obtenez Y » : Cône ×3 → ×2 + ×1) : les lignes ont des
     clés différentes et Shopify les recompose après chaque modification. On ajuste donc la quantité TOTALE de la variante
     par étapes, en relisant le panier à chaque réponse : réduction sur la dernière ligne, ajout sur la première. */
  function changeGroup(vid, total) {
    total = Math.max(0, total);
    function lines(cart) {
      var first = null, sig = '', out = [];
      (cart.items || []).forEach(function (it, i) {
        if (String(it.variant_id) !== String(vid)) return;
        var s = JSON.stringify(it.properties || {});
        if (first === null) { first = i; sig = s; }
        if (s === sig) out.push({ line: i + 1, q: it.quantity });
      });
      return out;
    }
    function step(cart, n) {
      var L = lines(cart), sum = L.reduce(function (a, l) { return a + l.q; }, 0);
      if (!L.length || sum === total || n > 6) return Promise.resolve(cart);
      var t = sum > total ? L[L.length - 1] : L[0];
      var q = sum > total ? Math.max(0, t.q - (sum - total)) : t.q + (total - sum);
      return postJSON(R.cartChange, { line: t.line, quantity: q }).then(function (c) { return step(c, n + 1); });
    }
    return fetch(R.cartJson, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { return step(c, 0); });
  }
  function changeLine(line, qty, group) {
    var p = group ? changeGroup(group, qty) : postJSON(R.cartChange, { line: line, quantity: Math.max(0, qty) });
    return p.then(function () { return refreshCart(false); })
      .catch(function (err) { return refreshCart(false).then(function () { cartMsg(err.message); }); });
  }
  PD.changeLine = changeLine;
  function applyDiscount(code) {
    return postJSON(R.cartUpdate, { discount: code }).then(function () { return refreshCart(false); }).then(function (c) {
      var dc = (c.discount_codes || []).filter(function (x) { return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
      cartMsg(dc && dc.applicable === false ? 'Ce code ne s’applique pas à votre sélection.' : (dc ? 'Code « ' + code + ' » appliqué.' : 'Ce code n’est pas valable.'));
      return c;
    }).catch(function () { cartMsg('Ce code n’est pas valable.'); });
  }
  PD.applyDiscount = applyDiscount;
  /* formulaires produit : <form action="/cart/add" data-pd-add> → ajout en Ajax + ouverture du panier */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-pd-add]')) return;
    if (e.submitter && e.submitter.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    var btn = e.submitter || $('[type=submit]', f), msg = $('[data-add-msg]', f);
    if (btn) busy(btn); if (msg) msg.textContent = '';
    addForm(f).then(function () { if (btn) unbusy(btn); })
      .catch(function (err) { if (btn) unbusy(btn); if (msg) msg.textContent = err.message; });
  });

  /* ------------------------------------------------------------ recherche (suggestions Shopify) */
  function bindSearch(scope) {
    var ov = $('#ovSearch', scope) || $('#ovSearch'); if (!ov || ov.__pd) return; ov.__pd = 1;
    var q = $('input[type=search]', ov), box = $('.sres', ov); if (!q || !box) return;
    var initial = box.innerHTML, timer, seq = 0;
    var empty = box.getAttribute('data-empty') || 'Aucun luminaire ne correspond.';
    q.addEventListener('input', function () {
      clearTimeout(timer);
      var v = q.value.trim();
      if (v.length < 2) { box.innerHTML = initial; return; }
      timer = setTimeout(function () {
        var my = ++seq;
        fetch(R.suggest + '?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (my !== seq) return;
            var list = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!list.length) { box.innerHTML = '<p class="muted">' + esc(empty) + '</p>'; nb(box); return; }
            box.innerHTML = list.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              var fr = img ? '<span class="fr solo"><img src="' + esc(img) + (String(img).indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="64" height="80"></span>' : '<span class="fr slot"></span>';
              var ty = p.type || '', nm = String(p.title || '');
              if (ty && nm.toLowerCase().indexOf(ty.toLowerCase() + ' ') === 0) { nm = nm.slice(ty.length + 1); nm = nm.charAt(0).toUpperCase() + nm.slice(1); }
              var pr = p.price_min != null ? Math.round(parseFloat(p.price_min) * 100) : Math.round(parseFloat(p.price || 0) * 100);
              return '<a href="' + esc(p.url) + '">' + fr + '<span><b>' + esc(nm) + '</b><span>' + (ty ? esc(ty) + ' · ' : '') + money(pr) + '</span></span></a>';
            }).join('');
            nb(box);
          }).catch(function () {});
      }, 200);
    });
    $$('.sugg [data-q]', ov).forEach(function (b) { b.addEventListener('click', function () { q.value = b.getAttribute('data-q'); q.dispatchEvent(new Event('input')); q.focus(); }); });
  }

  /* ------------------------------------------------------------ lettre d'information (formulaires client .nlf)
     Plusieurs formulaires d'inscription sur une même page (accueil + pied de page) : Shopify renvoie le même
     état « inscrit / erreur » à tous. On envoie donc en arrière-plan et on écrit le message dans le SEUL
     formulaire utilisé ; si Shopify impose une vérification, envoi classique et tri des messages au retour. */
  var NLK = 'pd-nl-last';
  function nlMsg(f, txt, err) {
    var m = $('.msg', f); if (!m) return;
    m.textContent = txt || ''; m.classList.toggle('pd-err', !!err);
  }
  function bindNewsletter(scope) {
    $$('form.nlf', scope).forEach(function (f) {
      if (f.__pdnl) return; f.__pdnl = true;
      f.addEventListener('submit', function (e) {
        if (f.__pdNative) return;
        e.preventDefault();
        var inp = $('input[type="email"]', f), v = inp ? inp.value.trim() : '';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
          nlMsg(f, f.getAttribute('data-err'), true);
          if (inp) { inp.setAttribute('aria-invalid', 'true'); inp.focus(); }
          return;
        }
        if (inp) inp.removeAttribute('aria-invalid');
        var btn = $('button[type="submit"]', f); if (btn) btn.disabled = true;
        var native = function () {
          try { sessionStorage.setItem(NLK, f.id || ''); } catch (x) {}
          f.__pdNative = true; HTMLFormElement.prototype.submit.call(f);
        };
        fetch(f.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(f), credentials: 'same-origin' })
          .then(function (r) {
            if (/\/challenge/.test(r.url)) return native();
            if (/customer_posted=true/.test(r.url)) {
              nlMsg(f, f.getAttribute('data-ok'), false);
              if (inp) inp.value = '';
            } else nlMsg(f, f.getAttribute('data-err'), true);
            if (btn) btn.disabled = false;
          })
          .catch(function () { native(); });
      });
    });
  }
  /* retour d'un envoi classique : le message ne reste que dans le formulaire utilisé */
  function nlAfterReload() {
    var forms = $$('form.nlf').filter(function (f) { var m = $('.msg', f); return m && m.textContent.trim(); });
    if (forms.length < 2) return;
    var id = (location.hash || '').slice(1), last = '';
    try { last = sessionStorage.getItem(NLK) || ''; sessionStorage.removeItem(NLK); } catch (x) {}
    var keep = forms.filter(function (f) { return f.id && (f.id === id || f.id === last); })[0] || forms[0];
    forms.forEach(function (f) { if (f !== keep) nlMsg(f, '', false); });
  }

  /* ------------------------------------------------------------ démarrage + éditeur de thème */
  function init(scope) {
    scope = scope || document;
    bindHeader(scope); bindSearch(scope); bindFx(scope); bindNewsletter(scope);
    fillEta(scope); nb(scope === document ? document.body : scope); observe(scope);
    onScroll();
  }
  PD.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); nlAfterReload(); });
  else { init(document); nlAfterReload(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var t = e.target; if (!t) return;
    if ($('#ovCart', t)) refreshCart(true);
  });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target && $('#ovCart', e.target)) closeLayer(null, true); });
  /* retour arrière du navigateur : page restaurée depuis le cache → panier à jour */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(false); });
})();
